<!--
 * @Auther: 罗耀祖
 * @Date: 2022-08-24 14:14:56
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-08-24 14:48:08
 * @name: 工单管理
 * @Description: 工单管理
 * @FilePath: \preSaleNafterSaleBackstage\src\views\issueManage\issueListManage.vue
 * @Author: desktop
-->
<template>
  <layout-normal>
    <table-normal>
      <template v-slot:title>
        <div class="title">工单列表</div>
      </template>
      <template v-slot:table>
        <el-table
          size="mini"
          :data="tableData.list"
          v-loading="loading"
          tooltip-effect="light"
          element-loading-text="数据加载中"
          fit
          :header-cell-style="{
            'background-color': $scssVars['Vars-background-bar-normal'],
            color: '#666',
          }"
          :style="{ fontSize: $scssVars['Vars-font-content-size'] }"
        >
          <el-table-column
            align="center"
            prop="id"
            label="ID"
            width="100"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="agency.agency_name"
            label="琴行名称"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="musical"
            label="乐器类别"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="piano_model"
            label="型号"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="piano_no"
            label="琴号"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="issue_name"
            label="问题类型"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="create_time"
            label="发起时间"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="sendToErp(scope.row)"
                >推送到ERP</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-slot:pagination>
        <Pagination
          class="pagination"
          v-if="pagination.page"
          :page.sync="pagination.page"
          :page-size.sync="pagination.limit"
          :total="tableData.total"
        >
        </Pagination>
      </template>
    </table-normal>
  </layout-normal>
</template>
<script>
import tableNormal from "@/components/public/table-normal.vue";
import { debounceation } from "@/utils/decorator";
import { issueGetList, issuePushErp } from "@/api/issue/issue.api";
export default {
  name: "issueListManage",
  components: {
    tableNormal,
  },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        total: 0,
      },
      pagination: {},
    };
  },
  watch: {
    //分页数据发送变化查询表格数据
    pagination: {
      handler(nv, ov) {
        nv.page && this.getTableData();
      },
      immediate: true,
      deep: true,
    },
  },
  activated() {
    this.initData(); //初始化数据
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化数据
     */
    @debounceation(300)
    initData() {
      this.initPagination(); //初始化分页信息
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化分页信息
     */
    initPagination() {
      this.pagination = {
        page: 1,
        limit: 10,
      };
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取表格数据
     */
    getTableData() {
      let params = { ...this.pagination };
      this.loading = true;
      issueGetList(params)
        .then((res) => {
          this.tableData.list = res.data.data;
          this.tableData.total = res.data.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 推送到erp
     */
    sendToErp(row) {
      issuePushErp({
        issue_id: row.id
      }).then(res => {
        this.$message.success('推送成功!');
        this.getTableData();
      })
    },
  },
};
</script>
<style lang="scss" scoped>
</style>